import { ProjectMemberRole, ProjectSlackInboxConfig, WorkingHours } from 'src/app/constants';

import { GlobalCustomField, SubStatus } from '.';

export const PROJECT_VISIBILITY = {
  PUBLIC: 'public',
  RESTRICTED: 'restricted',
} as const;

export type ProjectVisibility = (typeof PROJECT_VISIBILITY)[keyof typeof PROJECT_VISIBILITY];

export interface Project {
  id: string;
  name: string;
  description: string;
  visibility: ProjectVisibility;
  isExternal: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  defaultTriageChannelId: string | null;
  supportLogo: string | null;
  supportName: string | null;
  workingHours: WorkingHours | null;
  supportSteps: any[];
  defaultTicketTypeId?: string;
  instructions?: string | null;
  triageMessageTemplateId?: string | null;
  approvePrefillAfterStatusId?: string | null;
  approvePrefillAfterStatus?: SubStatus | null;
  fields?: GlobalCustomField[];
  slackInboxConfig?: ProjectSlackInboxConfig | null;
  escalationSettings?: ProjectEscalationSettings | null;
  customTokens?: Record<string, any> | null;
  emojiActionsConfig: Record<string, string>;
  restrictManualTicketingToAgents: boolean;
  projectLevelPermissions?: ProjectLevelPermissions;
}

export interface ProjectMember {
  user?: {
    id: string;
    name: string;
    email: string;
    photo?: string;
  };
  userGroup?: {
    id: string;
    name: string;
  };
  userId?: string;
  userGroupId?: string;
  entityId: string;
  projectId: string;
  role: ProjectMemberRole;
}

export interface ProjectUser {
  user?: {
    id: string;
    name: string;
    email: string;
    photo?: string;
  };
  userId: string;
  projectId: string;
  role: ProjectMemberRole;
}

export interface ProjectEscalationSettings {
  sendUserFacingNotifications?: boolean;
}

export const PROJECT_PERMISSION_LEVELS = {
  AGENT_AND_SUBMITTER: 'agent_and_submitter',
  AGENT_ONLY: 'agent_only',
  ANYONE: 'anyone',
} as const;

export type ProjectPermissionLevel = (typeof PROJECT_PERMISSION_LEVELS)[keyof typeof PROJECT_PERMISSION_LEVELS];

export interface ProjectLevelPermissions {
  permissionLevelForEmojiConversationCreation?: ProjectPermissionLevel | null;
  permissionLevelForEmojiConversationClosing?: ProjectPermissionLevel | null;
  permissionLevelForEmojiConversationInProgress?: ProjectPermissionLevel | null;
  permissionLevelForEmojiConversationOnHold?: ProjectPermissionLevel | null;
}
